import { Component, OnInit } from '@angular/core';
import { DocsNames, TemplatesNames } from '../../../../dto/docs-names';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {HtmlTemplate} from '../../../../dto/templates/html-template';
import {OtherTemplatesService} from '../../../services/other-templates.service';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-other-templates',
  templateUrl: './other-templates.component.html',
  styleUrls: ['./other-templates.component.css']
})
export class OtherTemplatesComponent {
docsNames = DocsNames;
templatesNames = TemplatesNames;
  templates: HtmlTemplate[] = [];
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private templateService: OtherTemplatesService,
    private toastService: ToastService,
  ) {}


  ngOnInit(): void {
    this.templateService.getAll().subscribe(ts => {
      this.templates = ts;
    }, err => {
      this.toastService.error(err.error.message || err.error || err.message);
    });
  }

  addTemplate() {

  }
}
